import { createAsyncThunk } from '@reduxjs/toolkit';

import type { GatewayCreditselectionService } from 'commonTypes/api/gatewayCreditselectionService';
import type { IScenario } from 'commonTypes/api/scenarios/scenario';

import { mergeWithCurrentQuery, sendSentryClientErrorOnce } from 'shared/lib';

import { isAllowedScenario, scenarioApi, setLoading, setScenario } from 'entities/scenario';

import { getStartScenarioConfig } from './getStartScenarioConfig';

export const startScenarioThunk = createAsyncThunk<
  IScenario | undefined,
  Partial<GatewayCreditselectionService.PreApprovalsSearchClientRequest> | undefined
>('scenario/start', async (preapprovalData, { dispatch, rejectWithValue }) => {
  try {
    dispatch(setLoading(true));
    const { scenarioName, defaultUrl } = getStartScenarioConfig();

    const startResp = await dispatch(
      scenarioApi.endpoints.startFlow.initiate(scenarioName ? { scenario: scenarioName } : {}),
    ).unwrap();
    const flowId = startResp?.item;

    if (!flowId) {
      return rejectWithValue({ message: 'Missed flowId in startScenarioThunk' });
    }

    const sourceUrl = window.location.href;

    const nextResp = await dispatch(
      scenarioApi.endpoints.nextStep.initiate({
        flowId,
        sourceUrl,
        payload: preapprovalData
          ? {
              preApprovalRequestParams: preapprovalData,
            }
          : undefined,
      }),
    ).unwrap();

    if (nextResp.redirectUrl) {
      window.location.href = mergeWithCurrentQuery(nextResp.redirectUrl);
      return;
    }

    if (!isAllowedScenario(nextResp.step)) {
      window.location.href = mergeWithCurrentQuery(defaultUrl);
      return;
    }

    dispatch(setScenario(nextResp));

    return nextResp;
  } catch (err) {
    sendSentryClientErrorOnce('startScenarioThunk', err);
    return rejectWithValue(err);
  } finally {
    dispatch(setLoading(false));
  }
});
